module.exports = __webpack_public_path__ + "static/media/opakowania_3_B.9d398d9d.png";